import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/point";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
}) => {
  const { base } = useSectionContext();
  const initial = {
    description: "",
    measures: [],
    dimensions: []
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Point/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { input } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Point/Create": {
        fields: [
          "description",
          "dimensions",
          "measures",
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
